import {createTheme} from '@mui/material';

const sharedTheme = {
  typography: {
    fontFamily: 'Roboto, sans-serif'
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }

  //  spacing: ['8px','16px','24px' ...],
};

export const baseLightTheme = createTheme({
  ...sharedTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#555555',
      light: '#AAAAAA',
      dark: '#333333',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#00838F',
      light: '#4FB3BF',
      dark: '#005662',
      contrastText: '#F6F6F6'
    },
    customColors: {
      onlineCardBackground: '#707070',
      switchChecked: '#003892',
      switchUnchecked: '#A38400',
      trackDark: '#8796A5',
      trackLight: '#aab4be',
      responsiveAppBarSettings: '#EEEEEE',
      overviewStars: '#00838F',
      urlLink: '#005662',
      urlLinkLight: '#00FFFF',
      messageFont: '#606060',
      messageFontOwn: '#808080',
      messageFontSender: '#050505',
      messageFontSenderOwn: '#e0e0e0',
      messageBackground: '#4FB3BF',
      messageBackgroundOwn: '#555555',
      messageText: '#F6F6F6',
      messageTextOwn: '#F6F6F6'
    },
    background: {
      default: '#EEEEEE',
      paper: '#F6F6F6'
    },
    text: {
      primary: '#222222',
      secondary: '#222222',
      disabled: '#666666'
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5'
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5'
        }
      }
    }
  }
  //  secondary: { main: '#d42100', dark: '#d42100', light: '#d42100' },

  //  spacing: ['8px','16px','24px' ...],
  // typography: {
  //   fontFamily: 'Titillium Web, sans-serif',
  // },
  // components: {
  //   MuiButton: {
  //     defaultProps: {
  //       variant: 'contained',
  //       color: 'secondary',
  //     },
  //   },
  // },
});

export const lightTheme = {
  ...baseLightTheme,
  palette: {
    ...baseLightTheme.palette,
    customColors: {
      ...baseLightTheme.palette.customColors,
      contrastPrimary: baseLightTheme.palette.getContrastText(
        baseLightTheme.palette.primary.main
      )
    }
  }
};

export const baseDarkTheme = createTheme({
  ...sharedTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#2F2F2F',
      light: '#4f4f4f',
      dark: '#2A2a2a',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#707070',
      light: '#858585',
      dark: '#606060',
      contrastText: '#FFFFFF'
    },

    customColors: {
      onlineCardBackground: '#707070',
      switchChecked: '#003892',
      switchUnchecked: '#A38400',
      trackDark: '#8796A5',
      trackLight: '#aab4be',
      responsiveAppBarSettings: '#EEEEEE',
      overviewStars: '#FFD700',
      urlLink: '#FFA500',
      urlLinkLight: '#FFA500',
      messageFont: '#151515',
      messageFontOwn: '#949494',
      messageFontSender: '#050505',
      messageFontSenderOwn: '#e5e5e5',
      messageBackground: '#606060',
      messageBackgroundOwn: '#2F2F2F',
      messageText: '#FFFFFF',
      messageTextOwn: '#F6F6F6'
    },

    background: {
      default: '#050505',
      paper: '#242424'
    },

    text: {
      primary: '#F4F4F4',
      secondary: '#F4F4F4',
      disabled: '#666666'
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#303030'
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: '#f4f4f4',
          '&.Mui-checked': {
            color: '#606060'
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#f4f4f4'
          }
        },
        track: {
          backgroundColor: '#f4f4f4'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '& .MuiButton-root': {
            color: '#F4F4F4'
          }
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#F4F4F4',
          '&.Mui-checked': {
            color: '#F4F4F4'
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: '#303030'
        }
      }
    }
  }
});

export const darkTheme = {
  ...baseDarkTheme,
  palette: {
    ...baseDarkTheme.palette,
    customColors: {
      ...baseDarkTheme.palette.customColors,
      contrastPrimary: baseDarkTheme.palette.getContrastText(
        baseDarkTheme.palette.primary.main
      )
    }
  }
};
